var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.389,
    height: 17.944,
    viewBox: "0 0 9.389 17.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 9.389,
    height: 17.944,
    fill: "#2e343d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M9.382,8.419c0,1.618-.024,3.236.006,4.853a4.613,4.613,0,0,1-3.931,4.613,4.765,4.765,0,0,1-5.133-2.8A4.167,4.167,0,0,1,0,13.478Q0,11.157,0,8.835a.6.6,0,0,1,.4-.614.556.556,0,0,1,.656.2.92.92,0,0,1,.128.457c.009,1.448.042,2.9,0,4.345a3.467,3.467,0,0,0,3.647,3.536,3.478,3.478,0,0,0,3.306-2.768,3.142,3.142,0,0,0,.049-.575q0-5.02,0-10.039A2.132,2.132,0,1,0,3.925,3.31c-.009,1.139,0,2.278,0,3.416q0,2.944,0,5.887a.76.76,0,0,0,.982.779.731.731,0,0,0,.553-.686c.006-.157,0-.315,0-.473q0-3.644,0-7.289A.6.6,0,0,1,6.649,4.83a1.209,1.209,0,0,1,0,.123q0,3.837,0,7.674A1.926,1.926,0,0,1,5.194,14.55a1.946,1.946,0,0,1-2.463-1.906c-.007-1.524,0-3.049,0-4.573,0-1.577,0-3.154,0-4.731a3.326,3.326,0,1,1,6.651,0c0,.012,0,.023,0,.035q0,2.523,0,5.046",
    transform: "translate(0 0)",
    fill: "#2e343d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.16a505f172715b038ac8e0d048c88f79.svg";
export { ForwardRef as ReactComponent };